import React, { useMemo } from "react";

// @material-ui/core components
import { Checkbox, Grid } from "@mui/material";

// core components
import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";

import allergenen from "../../../../variables/allergenen";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { useController } from "react-hook-form";
import { useVestigingContext } from "../../../components/Forms/VestigingProvider";

function Allergenen({ classes }) {
  const { vestiging } = useVestigingContext();
  const appTarget = vestiging?.appTarget;

  const {
    field: { value: allergenenValue, onChange: allergenenOnChange },
  } = useController({ name: "allergenen" });
  const {
    field: { value: nonAllergenenValue, onChange: nonAllergenenOnChange },
  } = useController({ name: "nonAllergenen" });

  const isChecked = (key) => {
    const allergenenList = allergenenValue;

    if (allergenenList == null || allergenenList === "") {
      return false;
    } else {
      return JSON.parse(allergenenList).includes(key);
    }
  };

  const isCheckedNon = (key) => {
    const allergenenList = nonAllergenenValue;

    if (allergenenList == null || allergenenList === "") {
      return false;
    } else {
      return JSON.parse(allergenenList).includes(key);
    }
  };

  const onChange = (key, checked) => {
    const orgineleAllergenen = allergenenValue;

    let newAllergenen = [];

    if (orgineleAllergenen != null && orgineleAllergenen !== "") {
      newAllergenen = JSON.parse(orgineleAllergenen);
    }

    if (checked) {
      newAllergenen.push(key);
    } else {
      let indexKey = newAllergenen.indexOf(key);
      newAllergenen.splice(indexKey, 1);
    }

    allergenenOnChange(JSON.stringify(newAllergenen));
  };

  const onChangeNon = (key, checked) => {
    const orgineleAllergenen = nonAllergenenValue;

    let newAllergenen = [];

    if (orgineleAllergenen != null && orgineleAllergenen !== "") {
      newAllergenen = JSON.parse(orgineleAllergenen);
    }

    if (checked) {
      newAllergenen.push(key);
    } else {
      let indexKey = newAllergenen.indexOf(key);
      newAllergenen.splice(indexKey, 1);
    }

    nonAllergenenOnChange(JSON.stringify(newAllergenen));
  };

  const allergenenCheckboxen = useMemo(
    () =>
      Object.keys(allergenen).map((item, key) => {
        return (
          <div style={{ textAlign: "center" }}>
            <Checkbox
              checked={isChecked(item)}
              checkedIcon={<img src={"/img/allergenen/" + allergenen[item].icon_red_50} />}
              icon={<img src={"/img/allergenen/" + allergenen[item].icon_grey_50} />}
              onChange={(e) => onChange(item, e.target.checked)}
              tabIndex={-1}
            />
            <h6 style={{ textAlign: "center" }}>
              <TranslationWrapper tDefault={allergenen[item].label} tKey={"allergenen" + "." + "icon.label." + item} />
            </h6>
          </div>
        );
      }),
    [onChange, isChecked]
  );

  const nonAllergenenCheckboxen = useMemo(
    () =>
      Object.keys(allergenen).map((item, key) => {
        return (
          <div style={{ textAlign: "center" }}>
            <Checkbox
              checked={isCheckedNon(item)}
              checkedIcon={<img src={"/img/allergenen/" + allergenen[item].icon_red_50} />}
              icon={<img src={"/img/allergenen/" + allergenen[item].icon_grey_50} />}
              onChange={(e) => onChangeNon(item, e.target.checked)}
              tabIndex={-1}
            />
            <h6 style={{ textAlign: "center" }}>
              <TranslationWrapper tDefault={allergenen[item].label} tKey={"allergenen" + "." + "icon.label." + item} />
            </h6>
          </div>
        );
      }),
    [onChangeNon, isCheckedNon]
  );

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <h4>
                <TranslationWrapper
                  tDefault={"Selecteer de producten die in de allergenen lijst voorkomen"}
                  tKey={"producten.form.allergenen.label.allergenen"}
                />
              </h4>
            </Grid>

            <Grid container item wrap={"wrap"} xs={12}>
              {allergenenCheckboxen}
            </Grid>
            {appTarget !== "appv5.js" ? (
              <>
                <Grid item xs={12}>
                  <h4>
                    <TranslationWrapper
                      tDefault={"Selecteer de allergenen waar ze vrij van zijn."}
                      tKey={"producten.form.allergenen.label.nonAllergenen"}
                    />
                  </h4>
                </Grid>
                <Grid container item wrap={"wrap"} xs={12}>
                  {nonAllergenenCheckboxen}
                </Grid>
              </>
            ) : null}
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default Allergenen;
